let evolution3 = function(sketch) {
    sketch.shapes3 = [];
    sketch.core;
    sketch.tokenId3;
    sketch.zoom = -1200;

    sketch.setup = function() {
        let canvas = sketch.createCanvas(400, 400, sketch.WEBGL);
        canvas.parent('preview3');
        sketch.tokenId3 = window.tokenId || 1;
        sketch.randomSeed(sketch.tokenId3);
        let thirdOrbitAngle = sketch.random(sketch.TWO_PI) * 3;
        sketch.randomSeed(sketch.tokenId3);
        let numberOfShapes = sketch.floor(sketch.random(40, 51));
        sketch.core = new sketch.Shape3(0, sketch.color(sketch.random(200, 255), sketch.random(200, 255), sketch.random(200, 255), 200), 1.5, 0, 0);
        sketch.core.x = 0;
        sketch.core.y = 0;
        sketch.core.z = 0;
        sketch.core.type = 0;

        for (let i = 1; i <= numberOfShapes; i++) {
            let orbitRadius;
            let orbitSpeed;
            let orbitAngle;
            if (i % 3 === 0) {
                orbitRadius = 400;
                orbitSpeed = 0.005;
                orbitAngle = thirdOrbitAngle; 
            } else if (i % 2 === 0) {
                orbitRadius = 280;
                orbitSpeed = 0.01;
                orbitAngle = sketch.PI / 2;
            } else {
                orbitRadius = 160;
                orbitSpeed = 0.02;
                orbitAngle = 0; 
            }
            let initialAngle = (sketch.TWO_PI / numberOfShapes * i) + (sketch.PI / numberOfShapes);
            sketch.shapes3.push(new sketch.Shape3(i, sketch.color(sketch.random(255), sketch.random(255), sketch.random(255), 200), sketch.random(0.4, 0.6), orbitRadius, orbitSpeed, orbitAngle, initialAngle));
        }

        sketch.camera(0, 0, sketch.zoom, 0, 0, 0, 0, 1, 0);
    }

    sketch.draw = function() {
        sketch.background(0);
        sketch.orbitControl(4, 4);
        sketch.rotateX(sketch.PI / 4);

        sketch.core.display();
        sketch.core.update();

        for (let shape of sketch.shapes3) {
            shape.display();
            shape.update();
        }
    }

    sketch.Shape3 = function(index, color, scale, orbitRadius, speed, orbitAngle, angle) {
        this.index = index;
        this.orbitRadius = orbitRadius || 0; 
        this.orbitAngle = orbitAngle || 0;
        this.speed = speed || sketch.random(0.01, 0.03);
        sketch.randomSeed(sketch.tokenId3 + this.index);
        this.angle = angle || sketch.random(sketch.TWO_PI);
        this.rotX = sketch.random(sketch.TWO_PI);
        this.rotY = sketch.random(sketch.TWO_PI);
        this.rotZ = sketch.random(sketch.TWO_PI);
        this.rotSpeed = sketch.random(-0.005, 0.005);
        this.scale = scale || sketch.random(0.4, 0.6);
        this.scaleSpeed = sketch.random(0.001, 0.002);
        this.color = color;

        this.display = function() {
            sketch.push();
            sketch.translate(this.x, this.y, this.z);
            sketch.rotateX(this.rotX);
            sketch.rotateY(this.rotY);
            sketch.rotateZ(this.rotZ);
            sketch.scale(this.scale);
            sketch.fill(this.color);
            sketch.noStroke();
            sketch.sphere(50);
            sketch.pop();
        }

        this.update = function() {
            if (this.index > 0) {
                this.x = this.orbitRadius * sketch.cos(this.angle + this.orbitAngle);
                this.y = this.orbitRadius * sketch.sin(this.angle);
                this.z = this.orbitRadius * sketch.sin(this.angle + this.orbitAngle);
                this.angle += this.speed;
                this.rotX += this.rotSpeed;
                this.rotY += this.rotSpeed;
                this.rotZ += this.rotSpeed;
            } else {
                this.rotX += this.rotSpeed;
                this.rotY += this.rotSpeed;
                this.rotZ += this.rotSpeed;
                this.scale += this.scaleSpeed;
                if (this.scale > 1.7 || this.scale < 1.3) {
                    this.scaleSpeed = -this.scaleSpeed;
                }
            }
        }
    }
}

let myp53 = new p5(evolution3, 'preview3');






















